// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1__RG","comment":"styles_comment__3cA5Q"};